import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { LoadingIndicatorComponent } from '@unicup-ticketing/ui';
import { DrawState } from '@unicup-ticketing/service';
import { HeaderAppearanceEvents, ProfileUserDrawsStateStore } from '@unicup-ticketing/core';
import { AuthenticationStateStore } from '@unicup-ticketing/auth';
import { CustomerDrawItemComponent } from '../customer-draw-item/customer-draw-item.component';
import { injectDispatch } from '@ngrx/signals/events';

@Component({
  selector: 'ticketing-profile',
  providers: [ProfileUserDrawsStateStore],
  imports: [LoadingIndicatorComponent, CustomerDrawItemComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent implements OnInit {
  protected readonly authState = inject(AuthenticationStateStore);
  protected readonly givenName = computed(() => this.authState.idToken()?.user.givenName);
  protected readonly drawUserState = inject(ProfileUserDrawsStateStore);
  protected readonly currentDraws = computed(() => {
    const draws = this.drawUserState.profileDrawOverview();
    if (draws !== undefined) {
      return draws.filter(draw => draw.state !== DrawState.Created && draw.state !== DrawState.Completed);
    }
    return [];
  });
  protected readonly pastDraws = computed(() => {
    const draws = this.drawUserState.profileDrawOverview();
    if (draws !== undefined) {
      return draws.filter(draw => draw.state === DrawState.Completed);
    }
    return [];
  });

  private readonly dispatch = injectDispatch(HeaderAppearanceEvents);

  ngOnInit(): void {
    this.dispatch.requestUnhero();
    this.drawUserState.refresh();
  }
}
